import * as React from "react";
import { DataLayer } from "@grandvisionhq/analytics";
import { useIntl } from "@grandvisionhq/state";
import { timeSelectionOtherDayEvent, timeSelectionNewHourOtherDayEvent, timeSelectionNewHourSameDayEvent } from "../../../../../data-layer/v3/data-layer/actions.js";
import { useAppointmentDurationLabel } from "../../../../../hooks/v3/hooks/use-appointment-duration-label.js";
import useDataLayerInput from "../../../../../hooks/v3/hooks/use-data-layer-input.js";
import { useAppointmentContext } from "../../../../../pages/BookAppointment/context/v3/pages/BookAppointment/context/AppointmentContext.js";
import { useRoutingContext } from "../../../../../pages/BookAppointment/context/RoutingContext/v3/pages/BookAppointment/context/RoutingContext/context.js";
import { replaceTimeSlotQueryParameters } from "../../../../../utils/v3/utils/replace-time-slot-query-parameters.js";
import AppointmentPickDifferentTimeSlot from "./AppointmentPickDifferentTimeSlot.js";
const AppointmentPickDifferentTimeSlotContainer = ({
  onSelectTimeSlot: emitSelectTimeSlot,
  selectedTimeSlot,
  timeSlots,
  loading
}) => {
  const [{ setTimeSlot }, { timeSlot, type }] = useAppointmentContext();
  const [{ goTo }, { queryParams }] = useRoutingContext();
  const {
    getFormattedLabel,
    getLabel,
    dateTime: { formatDate }
  } = useIntl();
  const dataLayerInput = useDataLayerInput();
  const durationLabel = useAppointmentDurationLabel(type);
  const labels = React.useMemo(
    () => ({
      loading: getLabel("appointments.component.appointmentPickDifferentTimeSlot.loading"),
      noTimesAvailableOn: getFormattedLabel(
        "appointments.component.appointmentPickDifferentTimeSlot.noTimesAvailableOn",
        {
          labelData: {
            date: timeSlot ? `${formatDate(timeSlot.from, "long")}` : ""
          }
        }
      ),
      noTimesSelectAnotherDay: getLabel(
        "appointments.component.appointmentPickDifferentTimeSlot.noTimesSelectAnotherDay"
      ),
      selectAnotherDay: getLabel(
        "appointments.component.appointmentPickDifferentTimeSlot.selectAnotherDay"
      ),
      selectATime: getLabel("appointments.component.appointmentPickDifferentTimeSlot.selectATime"),
      selectATimeSubtitle: durationLabel ? getFormattedLabel(
        "appointments.component.appointmentPickDifferentTimeSlot.selectATimeSubtitle",
        {
          labelData: {
            duration: durationLabel
          }
        }
      ) : ""
    }),
    [durationLabel, formatDate, getFormattedLabel, getLabel, timeSlot]
  );
  const onClickPrevious = React.useCallback(() => {
    const { typeId, storeId, search, userLocation } = queryParams;
    const dataLayerEvent = timeSlots.length === 0 ? timeSelectionOtherDayEvent(dataLayerInput) : timeSelectionNewHourOtherDayEvent(dataLayerInput);
    DataLayer.pushEvent(dataLayerEvent);
    goTo("when", {
      typeId,
      storeId,
      search,
      userLocation
    });
  }, [dataLayerInput, goTo, queryParams, timeSlots.length]);
  const onSelectTimeSlot = React.useCallback(
    (timeSlot2) => {
      replaceTimeSlotQueryParameters(timeSlot2);
      setTimeSlot(timeSlot2);
      emitSelectTimeSlot(timeSlot2);
      const dataLayerEvent = timeSelectionNewHourSameDayEvent(dataLayerInput);
      DataLayer.pushEvent(dataLayerEvent);
    },
    [setTimeSlot, emitSelectTimeSlot, dataLayerInput]
  );
  return /* @__PURE__ */ React.createElement(
    AppointmentPickDifferentTimeSlot,
    {
      selected: selectedTimeSlot,
      labels,
      loading,
      timeSlots,
      onSelectTimeSlot,
      onClickPrevious
    }
  );
};
export {
  AppointmentPickDifferentTimeSlotContainer as default
};
//# sourceMappingURL=AppointmentPickDifferentTimeSlotContainer.js.map
